<template>
  <a-row id="globalHeader" align="center" :wrap="false">
    <a-col flex="auto">
      <a-menu
        mode="horizontal"
        @menu-item-click="doMenuClick"
        :selected-keys="selectedKeys"
      >
        <a-menu-item
          key="0"
          :style="{ padding: 0, marginRight: '38px' }"
          disabled
        >
          <div class="titlebar">
            <img class="logo" src="../assets/logo.png" />
            <div class="title">AIdati</div>
          </div>
        </a-menu-item>
        <a-menu-item v-for="item in visibleRoutes" :key="item.path">
          {{ item.name }}
        </a-menu-item>
      </a-menu>
    </a-col>
    <a-col flex="120px">
      <a-space :size="15">
        <!--        <div v-if="loginUserStore.loginUser.id">-->
        <!--          {{ loginUserStore.loginUser.userName ?? "无名" }}-->
        <!--        </div>-->
        <!--        <div v-else>-->
        <!--          <a-button type="primary" href="/user/login">登录</a-button>-->
        <!--        </div>-->
        <!-- 未登录状态 -->
        <template v-if="!loginUserStore.loginUser.id">
          <a-button type="primary" href="/user/login">登录</a-button>
        </template>
        <!-- 已登录状态：显示用户名和下拉菜单、暗夜模式按钮 -->
        <template v-else>
          <a-avatar
            :size="24"
            :image-url="loginUserStore.loginUser.userAvatar"
          />
          <a-dropdown>
            <a-button>
              {{ loginUserStore.loginUser.userName ?? "请输入用户名" }}
            </a-button>
            <template #content>
              <a-doption @click="router.push('/user/edit')">
                <icon-user />
                个人信息
              </a-doption>
              <a-doption @click="doLogout">
                <icon-poweroff />
                退出登录
              </a-doption>
            </template>
          </a-dropdown>
          <!-- 新增：主题切换按钮 -->
          <a-button
            shape="circle"
            type="text"
            @click="themeStore.toggleTheme"
            :style="{ marginRight: '10px' }"
          >
            <!-- 根据状态显示不同图标 -->
            <icon-moon-fill v-if="!themeStore.isDark" />
            <icon-sun-fill v-else />
          </a-button>
        </template>
      </a-space>
    </a-col>
  </a-row>
</template>
<script setup lang="ts">
import { routes } from "@/router/routes";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import checkAccess from "@/access/checkAccess";
import { useDarkModeStore } from "@/store/themeStore"; // 引入主题 store
import {
  IconMoonFill,
  IconPoweroff,
  IconSunFill,
  IconUser,
} from "@arco-design/web-vue/es/icon"; // 引入图标
import { userLogoutUsingPost } from "@/api/userController"; // 引入退出登录 API
import { Message } from "@arco-design/web-vue"; // 引入消息提示

const themeStore = useDarkModeStore(); // 初始化 store

const loginUserStore = useLoginUserStore();

const router = useRouter();
//当前选择的菜单选项
const selectedKeys = ref(["/"]);
//跳转时，自动更新选择的菜单选项
router.afterEach((to, from, failure) => {
  selectedKeys.value = [to.path];
});

//展示在菜单栏的路由数据
const visibleRoutes = computed(() => {
  return routes.filter((item) => {
    if (item.meta?.hideInMenu) {
      return false;
    } // 根据权限过滤菜单
    if (!checkAccess(loginUserStore.loginUser, item.meta?.access as string)) {
      return false;
    }
    return true;
  });
});

// 路由跳转事件
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};
// 退出登录逻辑
const doLogout = async () => {
  try {
    const res = await userLogoutUsingPost();
    if (res.data.code === 0) {
      Message.success("退出登录成功");
      // 【新增】重置主题为默认（亮色）
      themeStore.resetTheme();
      // 清除本地用户状态
      loginUserStore.setLoginUser({ userName: "未登录" });
      // 跳转到登录页或首页
      router.push("/");
    } else {
      Message.error("退出失败：" + res.data.message);
    }
  } catch (e) {
    Message.error("退出失败，请重试");
  }
};
</script>
<style scoped>
/* 为整个菜单栏设置背景色 */
#globalHeader {
  background-color: var(--color-bg-1);
}

/* 暗色模式下的特殊处理 */
body[arco-theme="dark"] #globalHeader {
  background-color: #232324; /* 比默认暗色稍浅的灰色 */
}
.logo {
  width: 47px;
  height: 47px;
  margin-right: 15px;
  border-radius: 10px;
}
.titlebar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.title {
  font-size: 20px;
  font-weight: bold;
}
</style>
